import { styled } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useIsMobile } from 'shared/hooks';

import { ButtonWithLoader } from '../controls';
import { StickyBottomActionContainer } from '../layout';

interface MobileBottomBarSubmitButtonProps {
    onClick?: () => void;
    isDirty?: boolean;
    isLoading?: boolean;
}

export default function MobileBottomBarSubmitButton({ onClick, isDirty, isLoading }: MobileBottomBarSubmitButtonProps) {
    const isMobile = useIsMobile();
    const { t } = useTranslation('common');

    if (!isMobile) {
        return null;
    }

    return (
        <Root>
            <StickyBottomActionContainer>
                <ButtonWithLoader fullWidth
                    variant="contained"
                    onClick={ onClick }
                    disabled={ !isDirty || isLoading }
                    loading={ isLoading }
                >
                    { t('save') }
                </ButtonWithLoader>
            </StickyBottomActionContainer>
        </Root>
    );
}

const Root = styled('span')(({ theme }) => ({
    height: theme.spacing(18)
}));
